/* Collection filtering, sorting and pagination via the Section Rendering API (keeps URLs shareable). */
(() => {
  if (window.__nsFacets) return;
  window.__nsFacets = true;
  const grid = () => document.getElementById('CollectionGrid');

  const load = async (url, push = true) => {
    const g = grid(); if (!g) return (location.href = url);
    const results = g.querySelector('[data-facets-results]');
    results?.classList.add('is-loading');
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', g.dataset.sectionId);
    try {
      const html = await fetch(u).then((r) => r.text());
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionGrid');
      if (!fresh) throw new Error('no grid');
      // keep the open drawer (it was portalled to <body>) but refresh its contents
      const drawer = document.getElementById('FacetsDrawer');
      const freshDrawer = fresh.querySelector('#FacetsDrawer');
      if (drawer && freshDrawer) drawer.querySelector('.facets__form').replaceWith(freshDrawer.querySelector('.facets__form'));
      g.querySelector('.container').replaceWith(fresh.querySelector('.container'));
      if (push) history.pushState({ facets: true }, '', url);
      document.dispatchEvent(new CustomEvent('ns:dom-updated', { detail: g }));
      NS.announce(g.querySelector('.cgrid__count')?.textContent || '');
      if (!push) return;
      const top = g.getBoundingClientRect().top + scrollY - 90;
      if (scrollY > top) scrollTo({ top, behavior: 'smooth' });
    } catch { location.href = url; }
  };

  const formUrl = (form) => {
    const drawerForm = document.querySelector('#FacetsDrawer .facets__form');
    const params = new URLSearchParams();
    if (drawerForm) new FormData(drawerForm).forEach((v, k) => { if (v !== '' && k !== 'sort_by') params.append(k, v); });
    const sort = document.querySelector('[data-facets-sort]');
    if (sort) params.set('sort_by', sort.value);
    return `${form.action.split('?')[0]}?${params}`;
  };

  let t;
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facets-form]'); if (!form) return;
    clearTimeout(t);
    t = setTimeout(() => load(formUrl(form)), e.target.type === 'number' ? 600 : 50);
  });
  document.addEventListener('submit', (e) => { const form = e.target.closest('[data-facets-form]'); if (form) { e.preventDefault(); load(formUrl(form)); } });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-facet-link]'); if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); load(a.href);
  });
  addEventListener('popstate', () => { if (grid()) load(location.href, false); });
})();
